"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepEquals = exports.usePrevious = exports.debounce = exports.getAdditionalCSSClasses = void 0;
const react_1 = require("react");
/**
 * Helper to return an optional CSS className prop if defined or an empty string otherwise to keep "undefined" and whitespace out of element classes
 *
 * @param cssClassProp An optional component prop that adds additional CSS classes to some tag
 *
 * @returns {string} The cssClassProp if defined, or an empty string
 */
function getAdditionalCSSClasses(cssClassProp) {
    return cssClassProp ? cssClassProp : "";
}
exports.getAdditionalCSSClasses = getAdditionalCSSClasses;
/**
 * Generic debounce function
 *
 * @param fn Function to debounce
 * @param wait Debounce timeout
 */
const debounce = (fn, wait) => {
    let timeout;
    return (...args) => new Promise(resolve => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => resolve(fn(...args)), wait);
    });
};
exports.debounce = debounce;
/**
 * Typescript implementation of usePrevious hook
 * Allows us to compare prevProps to newProps within other hooks
 *
 * @param value the value to retain as prev
 */
const usePrevious = (value) => {
    const ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        ref.current = value;
    });
    return ref.current;
};
exports.usePrevious = usePrevious;
/**
 * Generic deep equals comparison
 * Requires both objects in comparison are string indexed
 * (have string keys)
 *
 * @param object Object to compare
 * @param target Target of comparison
 */
const deepEquals = (object, target) => {
    if (!object && !target) {
        return true;
    }
    if ((object && !target) || (!object && target)) {
        return false;
    }
    if (!(object.$$typeof || target.$$typeof)) {
        if (Object.keys(object).length !== Object.keys(target).length) {
            return false;
        }
        for (const key of Object.keys(object)) {
            if (key in target) {
                if (typeof object[key] === "object" &&
                    typeof target[key] === "object") {
                    if (!(0, exports.deepEquals)(object[key], target[key])) {
                        return false;
                    }
                }
                else if (object[key] !== target[key]) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    return true;
};
exports.deepEquals = deepEquals;
//# sourceMappingURL=helpers.js.map